
const IconInfo = () => (
    <img width={20} src={require(`./info.png`).default} alt="imagen" />
)

const IconInfoPol = () => (
    <img width={20} src={require(`./info3.svg`).default} alt="imagen" />
)

const IconCheck = () => (<img width={22} src={require(`./check.png`).default} alt="imagen" />)

const IconFinish = () => (<img width={80} src={require(`./finish.png`).default} alt="imagen" />)

const IconCopy = ({click}: any) => (
    <img width={20} src={require(`./copy.png`).default} alt="imagen" onClick={click} />
)

const IconError = () => (<img width={70} src={require(`./error.svg`).default} alt="imagen" />)

export {
    IconInfo,
    IconCheck,
    IconFinish,
    IconCopy,
    IconInfoPol,
    IconError
}